import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsagesGroup_Remove_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ServiceUsagesGroup_Remove(
      $serviceUsagesGroupId: Id!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      removeResolvableMissionTypeServiceUsagesGroup(
        serviceUsagesGroupId: $serviceUsagesGroupId
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useRemoveResolvableMissionTypeServiceUsagesGroupMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ServiceUsagesGroup_Remove_Mutation,
  );
